import RichBody from "@/components/RichBody";
import RichContent from "@/components/RichContent";
import { isHtml } from "@/lib/richtext";

// Renders an article body: rich HTML (new editor) or legacy [[token]] markup.
export default function BodyView({ body }) {
  return isHtml(body) ? <RichContent html={body} /> : <RichBody body={body} />;
}
